<template>
  <div class="imageUploader">
    <vue-base64-file-upload
      v-bind:id="'uploader-' +  _uid"
      class="v1"
      accept="image/png,image/jpeg"
      image-class="v1-image"
      input-class="imageInput"
      :max-size="maxSize"
      @size-exceeded="onSizeExceeded"
      @load="onLoad"
    />
    <mu-icon
      :size="size"
      color="#0179d5"
      v-if="!isUploading"
      style="cursor: pointer"
      :value="icon"
      v-tooltip.bottom="label"
      @click.native="selectFile"
    >
    </mu-icon>
    <mu-circular-progress
      :size="size"
      v-if="isUploading"
      mode="determinate"
      :value="progress">
    </mu-circular-progress>
  </div>
</template>

<script>
  import VueBase64FileUpload from 'vue-base64-file-upload'
  import axios from 'axios'
  import config from '../../config/index'

  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";
  import MuFlatButton from "muse-ui/src/flatButton/flatButton";
  import MuIcon from "muse-ui/src/icon/icon";
  import MuIconButton from "muse-ui/src/iconButton/iconButton";

  let FileManager = {
    uploadFile(uri, width, height) {
      return axios.post(config.apiUrl + 'uploader/image', {
        file: uri,
        width: width,
        height: height
      })
    }
  };
  export default {
    props: {
      icon: {
        type: String,
        default: 'image'
      },
      label: {
        type: String
      },
      size: {
        type: Number,
        default: 22
      },
    },
    name: "image-uploader",
    components: {
      MuIconButton,
      MuIcon,
      MuFlatButton,
      MuCircularProgress,
      VueBase64FileUpload
    },
    data() {
      return {
        isUploading: false,
        maxSize: 3,
        progress: 0
      }
    },
    methods: {
      selectFile() {
        let el = this._uid;
        let self = this;
        $('#uploader-' + self._uid + ' .vue-base64-file-upload-wrapper input').click()
      },
      onLoad(dataURI) {
        let self = this;
        let progressConfig = {
          onUploadProgress: progressEvent => {
            self.progress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          }
        };
        self.isUploading = true;
        axios.post(config.apiUrl + 'uploader/image',
          {
            file: dataURI
          }, progressConfig)
          .then(response => {
            let url = response.data.secure_url;
            self.isUploading = false;
            self.progress = 0;
            self.$emit('onComplete');
            self.$emit('input', url);
          });
      },
      onSizeExceeded() {
        alert('File must not be above 3mb!')
      }
    }
  }
</script>
<style lang="less">
  .imageUploader {
    .media, .media-body {
      overflow: hidden;
      zoom: 1;
    }
    .media-body, .media-left, .media-right {
      display: table-cell;
      vertical-align: middle;
    }
    .imageUploader .media-body {
      padding-right: 4px;
      padding-bottom: 3px;
      width: 10000px;
      padding-left: 0 !important;
    }
    .vue-base64-file-upload-wrapper input {
      display: none !important;
    }
    .vue-base64-file-upload.v1 img {
      width: 110px;
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// ImageUploader.vue?30669ffa